// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ihuB8","list":"styles_list__xqu13"};